import { ValidationManager } from '@chegg/commerce-utils';
import React from 'react';
import { Row, StyledRequiredFieldsLegend, InputWrapper } from './styled';
import { getPaymentFieldErrorText, getPaymentFieldLabelText } from './helpers';
import MemoizedUserAddress from '../UserAddress';
import { PaymentFormDataFields, PaymentFormValidationFields } from '../UserAddress/constants';
import { getString } from '../../constants/Strings';
import { useAppSelector } from '../../hooks/useAppSelector';
import { configSelector } from '../../redux/ConfigState/ConfigState.selectors';
import { paymentSelector } from '../../redux/PaymentState/PaymentState.selectors';
import { FloatingInputWrapper } from '@chegg-ui/input-wrapper';
import CVVTooltip from './CVVTooltip';
var types = ValidationManager.types;
var CCFIELDS = types.CCFIELDS;
var FormInputs = function FormInputs(props) {
  var formData = props.formData,
    isEdit = props.isEdit;
  var config = useAppSelector(configSelector);
  var payment = useAppSelector(paymentSelector);
  var paymentForm = config.paymentForm,
    paymentErrorModal = config.paymentErrorModal;
  var formFields = payment.formFields;
  return /*#__PURE__*/React.createElement("fieldset", null, /*#__PURE__*/React.createElement(StyledRequiredFieldsLegend, null, getPaymentFieldLabelText(paymentForm, PaymentFormDataFields.ALL_REQUIRED_FIELDS) || getString('APP.FORM.LEGEND.REQUIRED_FIELDS')), /*#__PURE__*/React.createElement(FloatingInputWrapper, {
    labelText: getPaymentFieldLabelText(paymentForm, PaymentFormDataFields.NAME_ON_THE_CARD) || getString('APP.FORM.LABEL.NAME'),
    inputId: CCFIELDS.CARDHOLDER_NAME,
    isFloating: formData[CCFIELDS.CARDHOLDER_NAME].focused || !Boolean(formFields.cardholderName.empty),
    errorText: getPaymentFieldErrorText(paymentForm, paymentErrorModal, formFields[CCFIELDS.CARDHOLDER_NAME].error, PaymentFormValidationFields.REQUIRED_CARD_NAME, PaymentFormValidationFields.INVALID_CARD_NAME) || formData[CCFIELDS.CARDHOLDER_NAME].error
  }, /*#__PURE__*/React.createElement(InputWrapper, {
    id: CCFIELDS.CARDHOLDER_NAME,
    error: formFields.cardholderName.error
  })), !isEdit && /*#__PURE__*/React.createElement(FloatingInputWrapper, {
    labelText: getPaymentFieldLabelText(paymentForm, PaymentFormDataFields.CARD_NUMBER) || getString('APP.FORM.LABEL.NUMBER'),
    inputId: CCFIELDS.CARD_NUMBER,
    isFloating: formFields[CCFIELDS.CARD_NUMBER].focused || !Boolean(formFields.number.empty),
    errorText: getPaymentFieldErrorText(paymentForm, paymentErrorModal, formFields[CCFIELDS.CARD_NUMBER].error, PaymentFormValidationFields.REQUIRED_CARD_NUMBER, PaymentFormValidationFields.INVALID_CARD_NUMBER) || formData[CCFIELDS.CARD_NUMBER].error
  }, /*#__PURE__*/React.createElement(InputWrapper, {
    id: CCFIELDS.CARD_NUMBER,
    error: formFields.number.error
  })), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(FloatingInputWrapper, {
    helperText: getString('APP.FORM.LABEL.EXPIRATION.HELPER.TEXT'),
    labelText: getPaymentFieldLabelText(paymentForm, PaymentFormDataFields.EXPIRATION) || getString('APP.FORM.LABEL.EXPIRATION'),
    inputId: CCFIELDS.EXPIRATION_DATE,
    isFloating: formFields[CCFIELDS.EXPIRATION_DATE].focused || !Boolean(formFields.expirationDate.empty),
    errorText: getPaymentFieldErrorText(paymentForm, paymentErrorModal, formFields[CCFIELDS.EXPIRATION_DATE].error, PaymentFormValidationFields.REQUIRED_EXPIRATION_DATE, PaymentFormValidationFields.INVALID_EXPIRATION_DATE) || formData[CCFIELDS.EXPIRATION_DATE].error
  }, /*#__PURE__*/React.createElement(InputWrapper, {
    id: CCFIELDS.EXPIRATION_DATE,
    error: formFields.expirationDate.error
  })), /*#__PURE__*/React.createElement(FloatingInputWrapper, {
    trailingIcon: /*#__PURE__*/React.createElement(CVVTooltip, null),
    trailingIconClickable: true,
    labelText: getPaymentFieldLabelText(paymentForm, PaymentFormDataFields.CVV) || getString('APP.FORM.LABEL.CVV'),
    inputId: CCFIELDS.CVV,
    isFloating: formFields[CCFIELDS.CVV].focused || !Boolean(formFields.cvv.empty),
    errorText: getPaymentFieldErrorText(paymentForm, paymentErrorModal, formFields[CCFIELDS.CVV].error, PaymentFormValidationFields.REQUIRED_CVV, PaymentFormValidationFields.INVALID_CVV) || formData[CCFIELDS.CVV].error
  }, /*#__PURE__*/React.createElement(InputWrapper, {
    id: CCFIELDS.CVV,
    error: formFields.cvv.error
  }))), /*#__PURE__*/React.createElement(MemoizedUserAddress, null));
};
export default FormInputs;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/internals/PaymentForm/FormInputs.js
// module id = 4565
// module chunks = 11